/* eslint camelcase: 0 */
import { AlgoliaGatewayBase } from './base'
import { toHits, toQueryProps } from './translator/query'
import { toDoctorProps } from '@/gateways/Monitaro/translator/doctor'
import { FetchDoctor } from '@/infrastructure/network/Algolia/requests/doctor'
import { IQueryProps } from '@/entities/Query'

export default class Doctor extends AlgoliaGatewayBase {
  async clearCache() {
    await this.apiClient.clearCache(new FetchDoctor().index)
  }

  async FetchDoctor(query: IQueryProps) {
    const response = await this.apiClient.request(new FetchDoctor(query.word, toHits(query)))
    return {
      items: response.hits!.map((prop) => toDoctorProps(prop)),
      query: toQueryProps(response)
    }
  }
}
